import { FACE_BY_ID } from "~/lib/faces";
import { useFaceSeo } from "~/lib/seo/useSeo";
import { PaginaDisciplina } from "~/ui/PaginaDisciplina";

export function ReactNative() {
  const face = FACE_BY_ID["react-native"];
  useFaceSeo(face);

  return (
    <PaginaDisciplina
      rotulo="React Native"
      titulo="Um código só, nas duas lojas."
      intro="TypeScript de ponta a ponta, com saída para código nativo onde o desempenho exige. iOS e Android andam juntos, em vez de um ficar sempre uma versão atrás do outro."
      entrego={[
        {
          titulo: "Uma base de código",
          corpo: "Regra de negócio, validação e cliente de API compartilhados entre as duas plataformas.",
        },
        {
          titulo: "Saída para o nativo",
          corpo: "Quando uma tela não alcança o desempenho necessário, só ela desce para Kotlin ou Swift. O time não muda de rumo, o código muda.",
        },
        {
          titulo: "Pipeline de build",
          corpo: "Expo e EAS para build reproduzível, atualização pelo ar para correção rápida e distribuição em TestFlight e faixa interna.",
        },
        {
          titulo: "Pronto para produção",
          corpo: "Link direto, notificação, compra dentro do app, biometria, armazenamento seguro e auditoria de acessibilidade.",
        },
      ]}
      nota="Quando eu digo para não usar: 3D pesado em tempo real, síntese de áudio de baixa latência e qualquer coisa que dependa de recurso que a plataforma acabou de lançar. Nesses casos, nativo sai mais barato no fim."
    />
  );
}
